import React from "react";
import CocoContainer from "../components/CocoContainer";

const Coco = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CocoContainer />
    </div>
  );
};

export default Coco;
